class MFRGalleryGrid {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.selectors = {
      gallery: ".portfolio__gallery",
      filter: ".filter-item",
      item: ".grid-item",
      sizer: ".grid-item"
    }

    this.init()
  }

  init() {
    this.$gallery = this.$element.find(this.selectors.gallery)
    this.$filter = this.$element.find(this.selectors.filter)

    this.__handleIsotopeGrid()
    this.$filter.on("click", this.__handleIsotopeFilter.bind(this))
  }

  __handleIsotopeGrid() {
    this.$gallery.isotope({
      itemSelector: this.selectors.item,
      percentPosition: true,
      masonry: {
        columnWidth: this.selectors.sizer
      } 
    })
  }

  __handleIsotopeFilter(e) {
    const $currentTarget = $(e.currentTarget)
    const $noResult = '<div class="no-results"><p>No matches found.</p></div>'

    this.$gallery.isotope({ filter: $currentTarget.data('filter') })

    $currentTarget.parent().siblings().children().removeClass('is-active')
    $currentTarget.addClass('is-active')

    let resultCount = this.$gallery.data('isotope').filteredItems.length

    $('.no-results').remove()

    resultCount === 0 ? $($noResult).insertAfter(this.$gallery) : $('.no-results').remove()
  }
}